import Requester from '../../helpers/requester';
import { API_PATHS } from '../../helpers/endpoints';
import { HTTP_METHODS } from '../../helpers/constants';
export default {
  getApplicationParameters: async (data) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.PARAMETER_SETTINGS}/search${data}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  putApplicationParameter: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.PARAMETER_SETTINGS}/${data.id}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getApplicationDetailParameters: async (params) => {
    try {
      const { name, ...otherParams } = params;
      const queryString = new URLSearchParams(otherParams).toString();
      const url = `${API_PATHS.PARAMETER_DETAIL_SETTINGS}?code=${name}&${queryString}`;
      const response = await Requester.submit({
        url,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  putApplicationDetailParameter: async (payload, id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.PARAMETER_SETTINGS}/${id}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  deleteApplicationDetailParameter: async (params) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.PARAMETER_DETAIL_SETTING}?code=${params.code}&scope-id=${params.scopeId}&relation-id=${params.relationId}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addApplicationDetailParameter: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.PARAMETER_SETTINGS}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getScopes: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.PARAMETER_SCOPES}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
